// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mb10[data-v-57849f70] {\r\n  margin-bottom: 10px;\n}\n.mt20[data-v-57849f70] {\r\n  margin-top: 20px;\n}\r\n", ""]);
// Exports
module.exports = exports;
